import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { CrmBoard } from '@features/crm-board';

const { Title, Paragraph } = Typography;

export function CrmPage() {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Same hero band every other page uses, so CRM stops looking like an
          outlier next to Dashboard / Profile / Buy requests. */}
      <section
        className="brand-gradient"
        style={{
          borderRadius: 16,
          padding: 28,
          border: '1px solid var(--ant-color-border-secondary)',
        }}
      >
        <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
          {t('crm.title')}
        </Title>
        <Paragraph type="secondary" style={{ marginTop: 4, marginBottom: 0, maxWidth: '72ch' }}>
          {t('crm.subtitle')}
        </Paragraph>
      </section>

      <CrmBoard />
    </div>
  );
}
